// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XkFcE","gradient":"styles_gradient__3qCVe"};